export default "__VITE_ASSET__C3lHh15t__"